import * as React from "react";
export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fill={"#d7d7d7"}
        d="M20 10C20 12.4 19.15 14.6 17.74 16.32L23.71 22.29C23.9 22.48 24.01 22.74 24.01 23C24.02 23.27 23.91 23.53 23.72 23.72C23.53 23.91 23.27 24.02 23 24.01C22.74 24.01 22.48 23.9 22.29 23.71L16.32 17.74C14.6 19.15 12.4 20 10 20C4.49 20 0 15.51 0 10C0 4.49 4.49 0 10 0C15.51 0 20 4.49 20 10ZM2 10C2 14.43 5.57 18 10 18C14.43 18 18 14.43 18 10C18 5.57 14.43 2 10 2C5.57 2 2 5.57 2 10Z"
      />
    </svg>
  );
};
